export default __webpack_public_path__ + "img/938553fd9bffd76f40fcb2c5a1777229.png";